/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { CallbackHolder } from "abweb/utils/callback/CallbackHolder";

// Close to CallbackArg0Predicate but this takes 'newRoute' as an arg
export class ContinueRouteChangeCallbacks extends CallbackHolder {
  callUtilFirstFalse(continueRouteChangeContext) {
    for (let listener of this.getCallbacks()) {
      if (!listener(continueRouteChangeContext)) {
        return false;
      }
    }
    return true;
  }
}
//# sourceMappingURL=ContinueRouteChange.js.map
